import useSWR from 'swr'
import API from '../../utils/api'
import { getPersistData } from '../../app/hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/board/notice?page=1&maxData=99999999'

let swrData: any = getPersistData(KEY)

export function useNoticeList() {
	const { data: token } = useToken()
	const { data, mutate } = useSWR<any>(
		KEY,
		async (url) => {
			const response = await API.get(url, token + '', {})
			swrData = response.result?.result?.list

			return swrData
		},
		{ revalidateOnFocus: true }
	)

	return {
		noticeList: data,
		mutate: (value?: any) => {
			if (value != undefined) {
				swrData = value
			}
			return mutate()
		},
	}
}